import { VpButton } from '@vtmn-play/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Modal } from '@spo/storybook';
import { InputActionMeta } from 'react-select';
import { useSportsArchitectureModal } from '../../hooks/useSportArchitectureModal';
import { metaActions } from '../../utils/metaActions';
import { SelectionInput } from '../offerPosterModal/selectionInput/SelectionInput';
import './architecture.scss';

type ArchitectureModalProps = {
  isOpen: boolean;
  setIsOpenModal: (value: boolean) => void;
};

export const ArchitectureModal = ({
  isOpen,
  setIsOpenModal,
}: ArchitectureModalProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [selectedSport, setSelectedSport] = useState<number | null>(null);
  const [inputValue, setInputValue] = useState('');

  const { data: sports } = useSportsArchitectureModal(inputValue);

  const goToArchitecturePage = () => {
    if (selectedSport) {
      const params = new URLSearchParams();
      params.set('sportId', selectedSport.toString());
      navigate(`/personal-offer/architecture?${params}`);
      closeModal();
    }
  };

  const onInputChange = (search: string, actionMeta: InputActionMeta) => {
    if (actionMeta.action === metaActions.inputChange) {
      setInputValue(search);
    }
  };

  const closeModal = () => {
    setIsOpenModal(false);
    setSelectedSport(null);
    setInputValue('');
  };

  const footerModal = (
    <>
      <VpButton
        data-testid="architecture_modal_cancel-button"
        variant="secondary"
        shape="squared"
        size="medium"
        onClick={closeModal}
      >
        {t('cancel')}
      </VpButton>
      <VpButton
        data-testid="architecture_modal_action-button"
        variant="primary"
        shape="squared"
        size="medium"
        onClick={goToArchitecturePage}
        disabled={!selectedSport}
      >
        {t('architecture.modal.select-sport')}
      </VpButton>
    </>
  );

  return (
    <Modal
      dataTestid="architecture_modal"
      footer={footerModal}
      isOpen={isOpen}
      title={t('architecture.modal.title')}
      ariaLabel="Architecture Modal"
      onClose={closeModal}
    >
      <div className="modal-architecture-body">
        <div className="architecture-modal-subtitle">
          {t('architecture.modal.subtitle')}
        </div>
        <SelectionInput
          entities={sports}
          selectedEntity={selectedSport}
          onInputChange={onInputChange}
          entityType="sport"
          handleEntitySelection={setSelectedSport}
          architecture
        />
      </div>
    </Modal>
  );
};
